import RechargeRecord from '@/views/webpc//CashierDesk/RechargeRecordApp/RechargeRecord'

// 定义路由路径数列表
export default [{
  path: '/rechargeRecord',
  name: '充值记录',
  component: RechargeRecord
}]



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/RechargeRecordApp/routers/index.js